import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { SrIcon } from "@/components/ui/SrIcon";
import { TONE_PILL } from "@/lib/widget-status";
import {
  BRANCH_STATUS_LABEL,
  WORKSPACE_BRANCHES,
  branchPath,
  type BranchStatus,
  type WorkspaceBranch,
} from "@/lib/tilbudsarbeidsrom/branches";

const STATUS_CLASS: Record<BranchStatus, string> = {
  klar: TONE_PILL.reached,
  pabegynt: TONE_PILL.near,
  tom: "bg-background/60 text-muted-foreground",
  kommer: "bg-background/60 text-muted-foreground",
};

interface WorkspaceBranchTabsProps {
  offerId: string;
  active: WorkspaceBranch;
  statuses: Record<WorkspaceBranch, BranchStatus>;
}

/** Grenene i tilbudsarbeidsrommet. Lenker, så tilbakeknapp og delte lenker virker. */
export function WorkspaceBranchTabs({ offerId, active, statuses }: WorkspaceBranchTabsProps) {
  return (
    <nav aria-label="Grener i tilbudet" className="overflow-x-auto mb-4">
      <div className="inline-flex h-10 items-center gap-0.5 rounded-md bg-muted p-1 text-muted-foreground">
        {WORKSPACE_BRANCHES.map((b) => {
          const isActive = b.key === active;
          return (
            <Link
              key={b.key}
              to={branchPath(offerId, b.key)}
              aria-current={isActive ? "page" : undefined}
              className={cn(
                "inline-flex items-center gap-1.5 whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all",
                "hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                isActive && "bg-background text-foreground shadow-sm",
              )}
            >
              <SrIcon name={b.icon} className="w-3.5 h-3.5" />
              {b.label}
              <span className={cn("rounded-full px-1.5 py-px text-[10.5px] font-medium", STATUS_CLASS[statuses[b.key]])}>
                {BRANCH_STATUS_LABEL[statuses[b.key]]}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
